export const environment = {
  version: '0.3.24',
  production: false,
  // pet24api.pet24app.com
  userUrl: 'https://pet24api.pet24app.com/',
  BASE_URL: 'https://pet24api.pet24app.com/',
  msUserUrl: 'https://pet24api.pet24app.com/',
  confirmation: "https://pet24api.pet24app.com/suscriptor/epayco/notification",
  response: "https://dev.pet24app.com/client/appointment-management/appointment",
  epaycoTest: true,
  key: '89e51f565622ce2c64a7b7b6f038e634',
  epaycoSessionEndpoint: 'https://pet24api.pet24app.com/epayco/create-session'
};
